import { useEffect, useState } from 'react';
import { onNote } from '../components/shared/messages';
import { GetNotes } from '../api/services/shared';
import { NoteStatusEnum } from '../components/shared/constants';

export const useNotesToast = ({
  hotelId,
  reservationId,
  reservationNumber,
  status = [NoteStatusEnum.Open],
}) => {
  const [notes, setNotes] = useState([]);

  useEffect(() => {
    (async () => {
      if (!(hotelId && reservationId)) return;
      const notes = await GetNotes({
        HotelID: hotelId,
        EntityTypeId: 1,
        EntityId: reservationId,
        Status: status,
      });
      setNotes(notes);

      if (
        notes.length &&
        notes.some(
          (note) =>
            note.EntityID == reservationId &&
            status.some((s) => s == note.Status)
        )
      )
        onNote({ reservationId, hotelId, reservationNumber });
    })();
  }, [hotelId, reservationId, reservationNumber, status]);

  return { notes };
};
